<template>
  <card>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h2>
            {{parameters.name}}
            <span>參數設定</span>
          </h2>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">啟用LINE點餐</label>
              <n-switch v-model="parameters.isEnabled" @click.native="shopStatus(parameters.accountId)" color="green">
                <!-- <i class="now-ui-icons ui-1_check" slot="on"></i>
                <i class="now-ui-icons ui-1_simple-remove" slot="off"></i> -->
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-exclamation" style="color:red;" slot="off"></i>
              </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">菜單樣式 <span v-if="parameters.isNewStyle == true">(單欄)</span><span v-if="parameters.isNewStyle !== true">(雙欄)</span></label>
              <n-switch v-model="parameters.isNewStyle">
                <!-- <i class="now-ui-icons ui-1_check" slot="on"></i>
                <i class="now-ui-icons ui-1_simple-remove" slot="off"></i> -->
                  <i class="fa fa-list" style="color:#BA0000;" slot="on"></i>
                  <i class="fa fa-columns" style="color:#0000BA;" slot="off"></i>
              </n-switch>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">顯示統一編號欄位</label>
            <n-switch v-model="parameters.isInvoice" color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">提供收據</label>
            <n-switch v-model="parameters.isReceipt" color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">啟用內用</label>
            <n-switch v-model="parameters.isEatIn"  color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">啟用外帶</label>
            <n-switch v-model="parameters.isToGo"  color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <label class="col-8 col-sm-6 col-form-label">啟用外送</label>
            <n-switch v-model="parameters.isDelivery"  color="green">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </div>
        </div>
      </div>
      
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">商店Email*</label>
                <div class="col-sm-8">
                  <fg-input name="email" placeholder="Email" v-model="parameters.businessEmail"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">商店電話*</label>
                <div class="col-sm-8">
                  <fg-input name="phone" type="tel" placeholder="Phone" v-model="parameters.businessPhone"></fg-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-2 col-form-label">商店地址*</label>
            <div class="col-sm-6">
              <fg-input name="address" placeholder="Address" v-model="parameters.businessAddress"></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">內用準備時間（分鐘）</label>
                <div class="col-sm-8">
                  <fg-input placeholder="" v-model="parameters.eatInWaitingTime"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">外帶準備時間（分鐘）</label>
                <div class="col-sm-8">
                  <fg-input placeholder="" v-model="parameters.toGoWaitingTime"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">外送準備時間（分鐘）</label>
                <div class="col-sm-8">
                  <fg-input placeholder="" v-model="parameters.deliveryWaitingTime"></fg-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-4">
                  <label class="col-form-label">商品庫存重置時間</label>
                </div>
                <div class="col-sm-8">
                  <el-select class="select-success" v-model="parameters.resetTime" placeholder="Select">
                    <el-option
                      v-for="item in resetTimeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">{{displayDeliveryAmtTh}}</label>
                <div class="col-sm-8">
                  <fg-input placeholder="餐點準備時間Ex 10" v-model="parameters.deliveryAmtTh"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">{{displayDeliveryQtyTh}}</label>
                <div class="col-sm-8">
                  <fg-input placeholder="上架商品重置時間Ex 00:10:00" v-model="parameters.deliveryQtyTh"></fg-input>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">最長外送距離（公里）</label>
                <div class="col-sm-8">
                  <fg-input
                    placeholder="上架商品重置時間Ex 00:10:00"
                    v-model="parameters.deliveryDistanceTh"
                  ></fg-input>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">可預訂天數（天）</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="可預訂天數Ex 10" type="number" min="0" v-model="numOfReservedDay"></fg-input>
                      <span
                          slot="helpBlock"
                          class="form-text"
                        >天數設定為1只開放當天點餐，天數為2則可預訂隔天，以此類推; 設為0只有立即選項。</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">時間選項間隔(分鐘)</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="上架商品重置時間Ex 00:10:00" type="number" min="1" v-model="parameters.timeSectorLength"></fg-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="row">
                    <label class="col-sm-4 col-form-label">供餐時段數</label>
                    <div class="col-sm-8">
                      <fg-input placeholder="" v-model="timeSectorsLengthDisplay" disabled>
                        <el-button slot="addonRight" type="success" icon="el-icon-edit" size="small" @click="dialogFormVisible = true">修改時段</el-button>
                      </fg-input>
                    </div>
                  </div>
                </div>
              </div>

          <div class="row">
            <label class="col-sm-2 col-form-label">營業資訊</label>
            <div class="col-sm-10">
              <el-input
                  type="textarea"
                  placeholder=""
                  v-model="parameters.storeInfo"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
            </div>
          </div>
          <br>
          <div class="row">
            <label class="col-sm-2 col-form-label">自動回應訊息</label>
            <div class="col-sm-10">
              <fg-input placeholder v-model="parameters.autoReply"></fg-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">公告</label>
            <div class="col-sm-10">
              <quill-editor
                class="notranslate"
                v-model="content"
                ref="myTextEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
              ></quill-editor>
            </div>
          </div>
          <!-- <div class="row">
            <label class="col-sm-2 col-form-label">公告</label>
            <div class="col-sm-10">
              <fg-input placeholder v-model="parameters.content"></fg-input>
            </div>
          </div> -->
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <n-button type="default" @click.native="back">返回</n-button>
        </div>
        <div class="col-sm-6">
          <n-button type="warning" @click.native="save" :disabled="saveDisabled">儲存</n-button>
        </div>
      </div>
    </div>
    <!-- 預約時間設定 -->
    <el-dialog title="供餐時間設定" width="40%" :visible.sync="dialogFormVisible" center>
      <br>
      <!-- datepicker -->
      <el-row>
        <el-col :span="18">
          <el-time-picker
            is-range
            v-model="timePickerValue"
            range-separator="到"
            start-placeholder="開始時間"
            end-placeholder="結束時間"
            :picker-options="timePickerOptions"
            value-format="HH:mm">
          </el-time-picker>
        </el-col>
        <el-col :span="2">
          <el-button type="warning" icon="el-icon-plus" size="small" @click="appendTimePickerArr" title="新增時間區段" style="height: 40px;">新增時段</el-button>
        </el-col>
      </el-row>
      <!-- end datepicker -->

      <el-table
          :data="timePickerObjArr"
          style="width: 100%">
        <el-table-column
          prop="start"
          label="開始時間">
        </el-table-column>
        <el-table-column
          prop="end"
          label="結束時間">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeTimePicker(scope)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="settingConfirm">確定</el-button>
      </span>
    </el-dialog>

  </card>
</template>

<script>
import {Select, Option} from 'element-ui'
import { Card, StatsCard } from "src/components";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { fetchShopInfo } from "../../../javascripts/eaa/fetchData";
import { shopEdit, shopStatus } from "../../../javascripts/eaa/updateData";
import swal from 'sweetalert2';

import axios from 'axios';
import moment from 'moment-timezone';

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    Card,
    StatsCard,
    Checkbox,
    Radio,
    FgInput,
    [Switch.name]: Switch,
    quillEditor,
    [Select.name]: Select,
    [Option.name]: Option
  },
  beforeRouteEnter(to, from, next) {
    let id = to.params.id;
    fetchShopInfo(id)
      .then(res => {
        console.log("res: ", res.data)
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      resetTimeOptions: [],
      saveDisabled: false,
      content: "",
      editorOption: {
        // some quill options
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],    //加粗，斜體，下劃線，刪除線
            // ['blockquote', 'code-block'],     //引用，程式碼塊
            // [{ 'header': 1 }, { 'header': 2 }],        // 標題，鍵值對的形式；1、2表示字型大小
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
            // [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下標
            // [{ 'indent': '-1'}, { 'indent': '+1' }],     // 縮排
            // [{ 'direction': 'rtl' }],             // 文字方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字型大小
            [{ 'color': [] }, { 'background': [] }],     // 字型顏色，字型背景顏色
            // [{ 'font': [] }],     //字型
            // [{ 'align': [] }],    //對齊方式
            ['clean'],    //清除字型樣式
          ]
        },
        placeholder: '請輸入公告...',
        theme: 'snow'
      },
      parameters: {
        
      },
      dialogFormVisible: false,
      timeArr : [{
        start: "",
        end: ""
      }],
      numOfReservedDay: 0,
      timeLengthArr: [{
        label: "5分鐘",
        value: 5
      },{
        label: "10分鐘",
        value: 10
      },{
        label: "15分鐘",
        value: 15
      },{
        label: "20分鐘",
        value: 20
      },{
        label: "30分鐘",
        value: 30
      },{
        label: "60分鐘",
        value: 60
      }],
      numOfReservedDayArr: [{
        label: "1天",
        value: 1
      },{
        label: "2天",
        value: 2
      },{
        label: "3天",
        value: 3
      },{
        label: "4天",
        value: 4
      },{
        label: "5天",
        value: 5
      },{
        label: "6天",
        value: 6
      },{
        label: "7天",
        value: 7
      }],
      settingTimeArr: [],
      timeSectorLength: 15,
      timePickerOptions: {
        format: 'HH:mm'

      },
      timePickerValue: ['00:00', '23:59'],
      timePickerObjArr: [],
      timeSectorsLengthDisplay: ""
    };
  },
  created() {
    for (let i = 0; i < 24; i++) {
      let hourString = i.toString().padStart(2, '00')
      this.resetTimeOptions.push({
        value: `${hourString}:00`,
        label: `${hourString}:00`
      })
    }
    console.log("this.resetTimeOptions: ", this.resetTimeOptions)
  },
  computed: {
    displayDeliveryAmtTh() {
      return this.parameters.isLala ? "免運費外送金額（元）" : "最低外送金額（元）";
    },
    displayDeliveryQtyTh() {
      return this.parameters.isLala ? "免運費外送數量（項）" : "最少外送數量（項）";
    }
  },
  methods: {
    findEnabledMealType() {
      var that = this;
      let mealTypes = ["isEatIn", "isToGo", "isDelivery"];
      var enabledMealTypes = [];
      for (let index = 0; index < mealTypes.length; index++) {
        if(that.parameters[mealTypes[index]]) {
          enabledMealTypes.push(mealTypes[index]);
        }
      }
      return enabledMealTypes;
    },
    checkIfMealTypeSettingValid() {
      let mealTypeArr = this.findEnabledMealType();
      if(mealTypeArr.length > 0 ){
        return true;
      } else {
        return false;
      }
    },
    setData(data) {
      data.isEatIn = data.isEatIn ? true : false;
      data.isDelivery = data.isDelivery ? true : false;
      data.isToGo = data.isToGo ? true : false;
      data.isEnabled = data.isEnabled ? true : false;
      data.isManual = data.isManual ? true: false;
      data.isNewStyle = data.isNewStyle ? true: false;
      data.isLala = data.isLala ? true: false;

      data.eatInWaitingTime =
          data.eatInWaitingTime == null
            ? Number(data.waitingTime)
            : Number(data.eatInWaitingTime);
        data.toGoWaitingTime =
          data.toGoWaitingTime == null
            ? Number(data.waitingTime)
            : Number(data.toGoWaitingTime);
        data.deliveryWaitingTime =
          data.deliveryWaitingTime == null
            ? Number(data.waitingTime)
            : Number(data.deliveryWaitingTime);

      if(data.content) {
        try {
          this.$refs.myTextEditor.quill.setContents(JSON.parse(data.content).ops);
        } catch(err) {
          let d = {
            ops: [{"insert": data.content}]
          };
          this.$refs.myTextEditor.quill.setContents(d);
          console.log(err);
        }
      }

      this.parameters = Object.assign({}, { ...data });
      this.convertToTimeObjArr(data.timeSetting);
      this.convertResetTimeToHour();
    },
    save() {
      this.parameters.content = JSON.stringify(this.$refs.myTextEditor.quill.getContents());
      this.parameters.version = 'newOrderTimeSetting';
      if(this.parameters.timeSectorLength <= 0) {
        this.$message({
          type: 'error', message: '時間選項間隔(分鐘)請輸入大於0的數字'
        });
      } else if(this.parameters.timeSectorDays < 0) {
        this.$message({
          type: 'error', message: '可預訂天數（天）請輸入大於等於0的數字'
        });
      } else if(!this.checkIfMealTypeSettingValid()) {
        this.$message({
          type: 'error', message: '請至少設定一種用餐方式'
        });
      } else {
        function checkIsValidForSettings(timePickerObjArr, numOfReservedDay, timeSectorLength) {
          function checkNumOfReservedDayZero(numOfReservedDay) {
            return numOfReservedDay == 0;
          }
          function checkTimeSectorLengthNotExistOrZero(timeSectorLength) {
            if(!timeSectorLength) {
              return true;
            } else if(timeSectorLength == 0) {
              return true;
            } else {
              return false;
            }
          }
          function genFullTimeObjArr(timeObjArr, numOfReservedDay, timeSectorLength) {
            let moment = require('moment-timezone')
            let date = moment().tz('Asia/Taipei').format('YYYY-MM-DD 00:00:00');
            var fullTimeObjArr = timeObjArr.map(t => {
                let start = t.start;
                let end = t.end;
                var arr = [];
                start = moment().tz('Asia/Taipei').format('YYYY-MM-DD') + " " + start + ":00"
                end = moment().tz('Asia/Taipei').format('YYYY-MM-DD') + " " + end + ":00"
                timeSectorLength = typeof timeSectorLength == 'number' && Number(timeSectorLength) ? timeSectorLength : 5;
                while(start <= end) {
                    arr.push(moment(start).format("HH:mm"))
                    start = moment(start).add(Number(timeSectorLength), "m").format("YYYY-MM-DD HH:mm");
                }
                return arr;
            });
            let concatArr = fullTimeObjArr.reduce((acc, val) => acc.concat(val), []);
            let uniqueArr = [...new Set(concatArr)];
            let numOfSpanTime = uniqueArr.length;
            return numOfSpanTime * numOfReservedDay;
          }
          if(checkNumOfReservedDayZero(numOfReservedDay)) {
            return true;
          } else if(checkTimeSectorLengthNotExistOrZero(timeSectorLength)) {
            this.$message({
              type: 'error', message: '請設置「時間選項間隔(分鐘)」'
            });
            return false;
          } else {
            let numOfTime = genFullTimeObjArr(timePickerObjArr, numOfReservedDay, timeSectorLength);
            if(numOfTime > 3367) {
              return false
            } else {
              return true;
            }
          }
        }
        let NUMOFRESERVEDDAY = Number(this.numOfReservedDay);
        let TIMESECTORLENGTH = Number(this.parameters.timeSectorLength);
        if(checkIsValidForSettings(this.timePickerObjArr, NUMOFRESERVEDDAY, TIMESECTORLENGTH)) {
          this.saveDisabled = true;
          shopEdit(this.parameters)
          .then(res => {
            this.$message({
                type: 'success', message: '修改成功'
              });
            this.saveDisabled = false;
          })
          .catch(err => {
            this.$message({
              type: 'error', message: '修改失敗'
            });
            console.log("err: ", err.stack);
            this.saveDisabled = false;
          });
        } else {
          this.$message({
            type: 'error', message: '供餐時段設定過於密集，請嘗試調整「時間選項間隔(分鐘)」及「供餐時段」'
          });
        }
      }
      
    },
    shopStatus() {
      shopStatus(this.parameters)
      .then(res => {
        swal("線上接單狀態已更改")
      })
      .catch(err => {
        console.log("err: ", err)
      });
    },
    back() {
      window.history.back();
    },
    appendTimeArr() {
      this.timeArr.push({
        start: "",
        end: ""
      });
    },
    appendTimePickerArr() {
      this.timePickerObjArr.push({
        start: this.timePickerValue[0],
        end: this.timePickerValue[1]
      });
      this.timePickerValue = ['00:00', '23:59']
    },
    settingConfirm() {
      if(this.timePickerObjArr.length > 0) {
        this.dialogFormVisible = false;
        
      } else {
        this.$message({
          type: 'error', message: '請至少設定一個時段'
        });
      }
    },
    remove(index) {
      this.timeArr.splice(index, 1);
    },
    removeTimePicker(scope) {
      this.timePickerObjArr.splice(scope.$index, 1);
    },
    calSettingTime() {
      let timeSectorLength = this.parameters.timeSectorLength;
      let sectorLenPerHr = 60 / timeSectorLength;
      let maxSector = 1 * 24 * sectorLenPerHr;
      let settingTimeArr = [];
      for (let sector = 0; sector <= maxSector; sector++) {
        let value = sector / sectorLenPerHr;
        if(value.toString().length <= 5) {
          let hr = Math.floor(value).toString().padStart(2, "0");
          let min = ((value % 1) * 60).toString().padStart(2, "0");
          settingTimeArr.push({
            label: `${hr}:${min}`,
            value: value
          });
        }
      }
      this.settingTimeArr = settingTimeArr;
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    convertToTime(numArr) {
      return numArr.map(t => {
        let s_h = Math.floor(t.start)
                .toString()
                .padStart(2, "0");
        let s_m = (t.start % 1 * 60)
                .toString()
                .padStart(2, "0");
        let e_h = Math.floor(t.end)
                .toString()
                .padStart(2, "0");
        let e_m = (t.end % 1 * 60)
                .toString()
                .padStart(2, "0");
        let start = `${s_h}:${s_m}`;
        let end = `${e_h}:${e_m}`;
        return {
          start,
          end
        }
      })
      
    },
    convertToTimeObjArr(timeSettings) {
      let timeObjSectors = this.parameters.timeObjSectors;
      let timeSectorDays = this.parameters.timeSectorDays;

      if(timeObjSectors) {
        this.timePickerObjArr = JSON.parse(timeObjSectors);
        this.numOfReservedDay = timeSectorDays;
      } else if(timeSettings) {
        let timeSettingArr = timeSettings.split(",");
        let days = timeSettingArr.pop();
        this.numOfReservedDay = Number(days);
        this.timeArr = timeSettingArr.map((timeStr, index) => {
          let start = Number(timeStr.split('-')[0]);
          let end = Number(timeStr.split('-')[1]);
          return {
            start,
            end
          };
        });
        this.timePickerObjArr = this.convertToTime(this.timeArr);
        console.log("this.timePickerObjArr: ", this.timePickerObjArr)
      }
    },
    convertResetTimeToHour() {
      let resetTime = this.parameters.resetTime;
      let resetTimeHour = resetTime ? resetTime.slice(0, 3) + "00" : null;
      this.parameters.resetTime = resetTimeHour;
      return this.parameters.resetTime;
    }
  },
  watch: {
    timePickerObjArr: function() {
      this.timeSectorsLengthDisplay = `${this.timePickerObjArr.length}`;
      this.parameters.timeObjSectors = this.timePickerObjArr;
    },
    numOfReservedDay: function(val) {
      this.parameters.timeSectorDays = val;
    }
  }
};
</script>